import { f7 } from 'framework7-vue'

export const showPreloader = (title: string) => {
  const dialog = f7.dialog.preloader(title)
  let closed = false
  const markClosed = () => {
    closed = true
  }

  dialog.once('close', markClosed)
  dialog.once('beforeDestroy', markClosed)

  return (animate?: boolean): void => {
    if (closed) return
    closed = true
    dialog.close(animate)
  }
}
